// Forces all select elements to cause their parent form to trigger an action.
export default () => {
  const selects = document.querySelectorAll(".select-container.select-container--immediate select");
  for (let index = 0; index < selects.length; index++) {
    const select = selects[index];
    const selectForm = select.form;
    select.addEventListener("change", () => {
      selectForm.submit();
    });
  }
};
